export const GROUP_TYPES = {
	DEFAULT: 'DEFAULT',
	SAWTOOTH: 'SAWTOOTH'
};

export const INVERT_Y_AXIS = true;

export const GAP_THRESHOLD = 15;
